<template>
    <div class="modal fade reviewreminderbox" id="reviewremindermodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div style="border-radius: 20px" class="modal-content mx-3 my-auto">
                <div class="container-fluid transit popup-box">
    
                <div class="row d-flex my-3">
                    <div class="col">
                        <div style="width: 50%;" class="logo mx-auto">
                            <img class="img-fluid logo" src="@/assets/dark-tree.svg" alt="myapptree logo" />
                        </div>
                    </div>
                </div>
                
                <div class="text-center modal-text">
                    <span data-text="welcomeback" class="localize" v-html="locale.welcomeback">Hey there! <b>Welcome</b> back again :)</span>
                    <br><br>
                    <span data-text="leavereview" v-html="locale.opinion_is_important"><h5>Your opinion is important to us!<br>How much are you enjoying your MyAppFree experience? &nbsp; </h5></span>

                    <Stars v-on:stars-click="starsClick"></Stars>

                </div>

                <div v-if="!isgoodrate" class="md-form animated zoomIn">
                    <textarea id="issueArea" maxlength="100" class="md-textarea form-control" :placeholder="locale.feedback_placeholder" rows="3"></textarea>
                </div>
                <button type="button" :disabled="disabled" v-on:click="rateNow()"
                    class="btn-sm btn btn-downloadapp w-100 p-0 buttonLink mt-3 align-bottom d-block p-2">
                    <!-- rimettere il localized solo quando è gestita la localizzazione di tutte e 3 le frasi -->
                    <!-- <span class="localize" data-text="rate">{{ buttontext }}</span> -->
                    <span data-text="rate">{{ buttontext }}</span>
                </button>
                <div class="row">
                    <div class="col">
                    <div class="d-flex justify-content-between my-3">
                        <a href="#" class="localize" data-text="notnow" v-html="locale.not_now" data-dismiss="modal">Not now</a>
                        <a href="#" v-on:click="neverAgain();" class="localize" v-html="locale.never_again" data-text="neveragain" data-dismiss="modal">Don't ask me again</a>
                    </div>
                    </div>
                </div>

                </div>
                </div>
            </div>
        </div>
</template>


<script>
import Stars from './Stars.vue'
// import axios from "axios";
// const util = require('./utility.js')
/* eslint-disable no-console*/
const $ = window.$;


export default {
  name: 'Rating',
  data(){
      return{
          buttontext: this.$locale.rating.review_btn_disabled,
          stars: 0,
          disabled: 'disabled',
          isgoodrate: true,
          locale: this.$locale.rating
      }
  },
  props: ['app'],
  methods: {
    emit: function(eventname) {
      this.$emit(eventname, this.app)
    },
    rateNow: function() {
        if (this.isgoodrate){
            if (window.Android !== undefined){
                // window.JSInterface.Click('https://play.google.com/store/apps/details?id=myappfreesrl.com.myappfree','myappfreesrl.com.myappfree',null,null)
                window.Android.goToPlayStore('https://play.google.com/store/apps/details?id=myappfreesrl.com.myapptree');   //remember to change package name
                window.Android.SendEvent('Rating', '')
            }else if(window.webkit){
                window.webkit.messageHandlers.iOS.postMessage({action: "requestReview"});
                window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "Rating"});
            }else
                window.location.href = 'https://play.google.com/store/apps/details?id=myappfreesrl.com.myapptree';  //remember to change package name
            // window.JSInterface.SetSettings('login_count', '0');
            $('#reviewremindermodal').modal('hide');
            localStorage.neverAgainReview = true;
        }else{
            if(document.getElementById("issueArea").value.length > 0 && document.getElementById("issueArea").value.length < 256){
                console.log(document.getElementById("issueArea").value);
                $('#reviewremindermodal').modal('hide');
                localStorage.neverAgainReview = true;

                /*below the logic to send a feedback email*/

                // let starstring = ""
                // for (let i = 0; i < this.stars; i++ ){
                //     starstring += "⭐";
                // }
                // axios.post('https://us-central1-myappfreeapp.cloudfunctions.net/sendMail', {
                //     appVersion: 'undefined',
                //     msg: document.getElementById("issueArea").value,
                //     country: window.country,
                //     os: window.os,
                //     lang: window.language,
                //     rating: this.stars,
                //     stars: starstring,
                //     url: window.location.href
                // }).then(response => { 
                //     if(window.JSInterface !== undefined)
                //         window.JSInterface.showToast(util.localize('thankyou', window.language));
                //     console.log(response)
                // })
                // .catch();
                
            }
        }
    },
    neverAgain: function() {
        // window.JSInterface.SetSettings('login_count', '0');
        localStorage.neverAgainReview = true;
    },
    starsClick: function(stars) {
        // alert('valore: '+ stars);
        this.stars = stars;
        if (stars > 0){
            this.disabled = null;
            switch(stars) {
                case '1':
                    this.buttontext = this.locale.rating1;
                    this.isgoodrate = false;
                    break;
                case '2':
                    this.buttontext = this.locale.rating2;
                    this.isgoodrate = false;
                    break;
                case '3':
                    this.buttontext = this.locale.rating3;
                    this.isgoodrate = false;
                    break;
                case '4':
                    this.buttontext = this.locale.rating4;
                    this.isgoodrate = false;
                    break;
                case '5':
                    this.buttontext = this.locale.rating5;
                    this.isgoodrate = true;
                    if(window.webkit){
                        window.webkit.messageHandlers.iOS.postMessage({action: "requestReview", param2: ""});
                        window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "Rating"});
                        $('#reviewremindermodal').modal('hide');
                        localStorage.neverAgainReview = true;
                    }
                    break;
                default:
                    console.log("err - stars: "+stars);
            }    
        }
    }
  },
    components: {
    Stars
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* .transit{
    -webkit-transition: max-height 1s; 
  -moz-transition: max-height 1s; 
  -ms-transition: max-height 1s; 
  -o-transition: max-height 1s; 
  transition: max-height 1s;
            } */
    .modal-text{
        color: white;
        text-shadow: grey;
    }
    .logo{
        max-width: 15vw;
    }
    
</style>
